<div *ngIf="dataRes.IsAddPaymentsNumbers;then AddPaymentsNumbers else AddPaymentsPercentages"></div>

<ng-template #AddPaymentsNumbers>
    <div class="bg-primary text-center">
        <h2 mat-dialog-title class="mat-mdc-dialog-title text-white">
            {{ 'EnterPaymentsNumber' | translate}}
        </h2>
    </div>

    <mat-dialog-content class="mat-mdc-dialog-content text-center">
        <form #PaymentNumbersForm="ngForm">
            <div class="col-md-12 m-b-20">
                <span class="span-title">{{ 'TotalCost' | translate}}</span>
                <span> {{dataRes.TotalCost}} {{ 'EGP' | translate}}</span>
            </div>

            <div class="col-md-12">
                <mat-form-field appearance="outline" class="w-100 m-b-10">
                    <mat-label>{{ 'PaymentsNumber' | translate}}</mat-label>
                    <input matInput type="number" placeholder="{{ 'PaymentsNumber' | translate}}" maxlength="3"
                        name="PaymentsNumber" ngModel #PaymentsNumber="ngModel" required />
                </mat-form-field>
            </div>
        </form>

        <div *ngIf="formErrors.length>0">
            <div *ngFor="let error of formErrors">
                <p class="validation-error">{{ error }}
                </p>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <mat-divider></mat-divider>
        <div class="col-md-12">
            <button class="btnConfirmation" (click)="ConfirmationNumbersForm(PaymentNumbersForm.value)">
                {{ 'confirmation' | translate}}
            </button>
            <button mat-button class="btnClose" (click)="onClose()"> {{ 'Cancel' | translate}}</button>
        </div>
    </mat-dialog-actions>
</ng-template>

<ng-template #AddPaymentsPercentages>
    <div class="bg-primary text-center">
        <h2 mat-dialog-title class="mat-mdc-dialog-title text-white">
            {{ 'EnterPaymentPercentages' | translate}}
        </h2>
    </div>

    <mat-dialog-content class="mat-mdc-dialog-content text-center">
        <form [formGroup]="PaymentPercentagesForm">
            <div class="col-md-12 m-b-20">
                <span class="span-title">{{ 'TotalCost' | translate}}</span>
                <span> {{dataRes.TotalCost}} {{ 'EGP' | translate}}</span>
            </div>

            <div class="col-md-12 m-b-20" *ngFor="let num of arr;let i=index">
                <mat-form-field appearance="outline" class="w-100 m-b-10">
                    <mat-label>{{ 'PercentagePayment' | translate}}</mat-label>
                    <input matInput type="number" placeholder="{{ 'PercentagePayment' | translate}}" maxlength="3"
                        formControlName="PercentagePayment{{i}}" />

                    @if(PaymentPercentagesForm.get('PercentagePayment'+i)?.touched &&
                    PaymentPercentagesForm.get('PercentagePayment'+i)?.invalid)
                    {
                    <mat-hint class="m-b-16 error-msg">
                        <div class="text-error"> {{ 'EnterPaymentPercentages' | translate }}</div>
                    </mat-hint>
                    }

                </mat-form-field>
            </div>
        </form>

        <div *ngIf="formErrors.length>0">
            <div *ngFor="let error of formErrors">
                <p class="validation-error">{{ error }}
                </p>
            </div>
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <mat-divider></mat-divider>
        <div class="col-md-12">
            <button class="btnConfirmation" (click)="ConfirmationPercentagesForm(PaymentPercentagesForm)">
                {{ 'confirmation' | translate}}
            </button>

            <button mat-button class="btnClose" (click)="onClose()"> {{ 'Cancel' | translate}}</button>
        </div>
    </mat-dialog-actions>
</ng-template>